import { supplierTypeList, width } from '../../components/componentsData';
export const fieldList = [
  {
    label: '申请单号',
    type: 'input',
    value: 'applyCode'
  },
  {
    label: '申请状态',
    type: 'select',
    value: 'applyStatus',
    list: 'applyStatusList'
  },
  {
    label: '申请企业',
    type: 'input',
    value: 'companyName'
  },
  {
    label: '供应商类型',
    type: 'select',
    value: 'supplierType',
    list: 'supplierTypeList'
  }
];

export const listTypeInfo = {
  width,
  supplierTypeList,
  // 全部、待确认、申请驳回、确认通过
  applyStatusList: [
    { name: '全部', id: '104' },
    { name: '待确认', id: '101' },
    { name: '申请驳回', id: '102' },
    { name: '确认通过', id: '103' }
  ]
};

export const tableLabel = [
  {
    label: '申请单号',
    param: 'applyCode',
    align: 'center',
    minWidth: 140,
    slot: 'applyCode'
  },
  {
    label: '申请企业',
    param: 'companyName',
    align: 'center',
    minWidth: 140
  },
  {
    label: '供应商类型',
    param: 'supplierType',
    align: 'center',
    minWidth: 180,
    slot: 'supplierType'
  },
  {
    label: '申请人',
    param: 'applicant',
    align: 'center',
    minWidth: 110
  },
  {
    label: '申请日期',
    param: 'applyTime',
    align: 'center',
    minWidth: 180
  },
  {
    label: '金额(元)',
    align: 'right',
    minWidth: 110,
    slot: 'amount'
  },
  {
    label: '申请状态',
    param: 'applyStatus',
    align: 'center',
    minWidth: 110,
    slot: 'applyStatus'
  },
  {
    label: '操作',
    align: 'center',
    fixed: 'right',
    width: '140',
    slot: 'handle',
    minWidth: 100
  }
];
